<template>
  <div class="content-v2">
    <div class="case-filter-v2">
      <button type="button" :class="{ active: activeCategory === '' }" @click="selectCategory('')">
        {{ $t('cases.allCategory') }}
      </button>
      <button
        v-for="item in categoryList"
        :key="item.categoryId"
        type="button"
        :class="{ active: activeCategory === String(item.categoryId) }"
        @click="selectCategory(item.categoryId)"
      >
        {{ item.categoryName }}
      </button>
    </div>
    <div class="operation-table-wrap">
      <table class="operation-table">
        <thead>
          <tr>
            <th>序号</th>
            <th>项目名称</th>
            <th>机组</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in caseList" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>
              <router-link :to="'/cases/operation/' + item.id">{{ item.title }}</router-link>
            </td>
            <td>{{ item.unit || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!caseList.length" class="case-empty-v2">暂无工程业绩</div>
  </div>
</template>

<script>
import { getCaseCategoryList, getCaseList } from '@/api/portal'

export default {
  name: 'CasesOperationV2',
  data() {
    return {
      activeCategory: '',
      categoryList: [],
      caseList: Array.from({ length: 6 }).map((_, index) => ({
        id: index + 1,
        title: [
          '印尼莫罗瓦利拉波塔电厂运维项目',
          '新兴县循环经济环保项目运营服务',
          '乾安县聚太生物质发电生产系统运维项目',
          '夏津县垃圾焚烧发电设备检修维护服务',
          '邹平光大环保能源设备日常检修维护项目',
          '微山县生活垃圾焚烧发电设备维护服务'
        ][index],
        unit: [
          '3×380MW',
          '500t/d',
          '生产系统',
          '全场设备',
          '全厂辅助设备',
          '生产系统及公用系统'
        ][index]
      }))
    }
  },
  created() {
    this.activeCategory = this.getRouteCategoryId()
    this.loadCategories()
    this.loadCases()
  },
  watch: {
    '$route.query.categoryId'() {
      this.activeCategory = this.getRouteCategoryId()
      this.loadCases()
    }
  },
  methods: {
    getRouteCategoryId() {
      return this.$route.query.categoryId ? String(this.$route.query.categoryId) : ''
    },
    loadCategories() {
      getCaseCategoryList().then(data => {
        this.categoryList = data || []
      }).catch(() => {})
    },
    loadCases() {
      const params = { caseType: 'operation', pageNum: 1, pageSize: 30 }
      if (this.activeCategory) {
        params.deptCategoryId = this.activeCategory
      }
      getCaseList(params).then(({ rows }) => {
        this.caseList = (rows || []).map(item => ({
          id: item.caseId,
          title: item.caseTitle,
          unit: item.unit || ''
        }))
      }).catch(() => {})
    },
    selectCategory(categoryId) {
      const nextCategory = categoryId ? String(categoryId) : ''
      this.activeCategory = nextCategory
      this.$router.push({
        path: '/cases/operation',
        query: nextCategory ? { categoryId: nextCategory } : {}
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.case-empty-v2 {
  padding: 56px 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  color: #94a3b8;
  text-align: center;
  background: #fff;
}

.operation-table-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.operation-table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;

  th,
  td {
    padding: 18px 22px;
    border: 1px solid #e2e8f0;
    color: #334155;
    font-size: 15px;
    line-height: 1.6;
    text-align: left;
  }

  th {
    background: #f8fafc;
    color: #0f172a;
    font-weight: 700;
  }

  th:first-child,
  td:first-child {
    width: 96px;
    text-align: center;
  }

  th:last-child,
  td:last-child {
    width: 220px;
  }

  tbody tr:hover {
    background: #f8fbff;
  }

  a {
    color: #0f172a;
    font-weight: 600;

    &:hover {
      color: #0f5fa8;
    }
  }
}

.case-filter-v2 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 28px;

  button {
    min-width: 82px;
    padding: 9px 18px;
    border: 1px solid #dbe5ef;
    border-radius: 999px;
    background: #fff;
    color: #475569;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;

    &:hover,
    &.active {
      border-color: #0ea5e9;
      color: #fff;
      background: linear-gradient(135deg, #10b981, #06b6d4);
      box-shadow: 0 8px 20px rgba(14, 165, 233, 0.18);
    }
  }
}

@media (max-width: 640px) {
  .operation-table {
    min-width: 620px;

    th,
    td {
      padding: 14px 16px;
      font-size: 14px;
    }
  }
}
</style>
